export const defaultState = () => {
  return {
    sectionsOrders: {
      left: [],
      right: [],
    },
    recentPages: [],
    newTemplates: [],
    topIntegrations: [],
    banner: [],
    blog: [],
    faqs: [],
    changelog: [],
    openCustom: false,
    loading: false,
    firstCallGetApi: false,
    isYearly: true,
    dynamicContentPricing: {},
    dynamicTriggerPricing: {},
    paymentInfo: {},
    pricingPageLoading: false
  };
};

const state = defaultState();

export default state;
